import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BdsButton from '../../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import CountUpNumber from '../../../../../../shared/components/v3/CountUpNumber/CountUpNumber';
import { COUNT_UP_DURATION } from '../../../../../../shared/constants/reports';
import { HOW_DISCOUNTS_WORK_LINK } from '../../../../../../shared/constants/requests';
import { CLICK_ACTION, HEALTH_REPORT_INSURANCE_USAGE } from '../../../../../../shared/constants/tagManager';
import useInView from '../../../../../../shared/hooks/useInView/useInView';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import TagManagerService from '../../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import { redirectToPage } from '../../../../../../shared/utils/utils';

import './RefundSuccessData.scss';

export const RefundSuccessData = ({
  data,
  isLastReport,
  inDownloadMode
}: {
  data: IHealthReport;
  isLastReport?: boolean;
  inDownloadMode?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ref: containerRef, enterCount: cycle } = useInView<HTMLDivElement>({
    threshold: 0.3,
    enabled: !inDownloadMode
  });

  const openInstructions = () => {
    TagManagerService.pushEvent(CLICK_ACTION, HEALTH_REPORT_INSURANCE_USAGE, { type: 'instructive' });
    redirectToPage(navigate, HOW_DISCOUNTS_WORK_LINK);
  };

  return (
    <div className="refund-success-data-container" ref={containerRef}>
      <p className="rsd-title">
        <span className="rsd-percentage">
          {inDownloadMode ? (
            `${data.usersApprovedClaimsPercentage ?? 0}%`
          ) : (
            <CountUpNumber
              key={`users-approved-${cycle}`}
              value={data.usersApprovedClaimsPercentage ?? 0}
              duration={COUNT_UP_DURATION}
              suffix="%"
            />
          )}
        </span>
        {` ${t(TRANSLATIONS_REPORTS.healthReport.refundSuccessData.title)}`}
      </p>
      <p className="health-report-description">{t(TRANSLATIONS_REPORTS.healthReport.refundSuccessData.description)}</p>
      {isLastReport && (
        <div className="only-landing">
          <BdsButton variant="quaternary" size="s" action={openInstructions}>
            {t(TRANSLATIONS_REPORTS.healthReport.refundSuccessData.button)}
          </BdsButton>
        </div>
      )}
    </div>
  );
};

export default RefundSuccessData;
